import { render, staticRenderFns } from "./ExportsButton.vue?vue&type=template&id=53b9690a&scoped=true"
import script from "./ExportsButton.vue?vue&type=script&lang=js"
export * from "./ExportsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9690a",
  null
  
)

export default component.exports